<template>
    <div class="container-fluid">
        <el-container>
            <el-header height="15%">
                <div class="row mt-4">
                    <div class="col-md-2">
                        <h4>Заказы</h4>
                    </div>
                </div>
            </el-header>
            <el-main height="80%">
                <el-form aria-label="Поиск">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="Номер заказа">
                                <el-col :span="14">
                                    <el-input v-model="query.orderId" @change="setQueryReset"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Имя">
                                <el-col :span="14">
                                    <el-input v-model="query.customerName" @change="setQueryReset"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="По поставкам">
                                <el-col :span="14">
                                    <el-checkbox v-model="onlySupply" @change="setQueryReset"></el-checkbox>
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="Статус">
                                <el-col :span="14">
                                    <el-select v-model="query.status" multiple clearable @change="setQueryReset" placeholder="Статус заказа">
                                        <el-option
                                            v-for="(item, index) in filterStatusConfig"
                                            :key="index"
                                            :value="item.field" :label="item.title"></el-option>
                                    </el-select>
                                </el-col>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item >
                                <el-select v-model="query.sort" :width="300" @change="setQuery" placeholder="сортировка">
                                    <el-option
                                        v-for="(it, index) in sortConfig"
                                        :key="index"
                                        :value="it.field"
                                        :label="it.title"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <el-table
                :data="orders"
                style="width: 100%"
                empty-text="Нет заказов">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Телефон: {{ props.row.user_info.phone }}</p>
                            <p>Email: {{ props.row.user_info.email }}</p>
                            <div v-if="props.row.delivery_info">
                            <p >
                                Адрес: ул. {{ props.row.delivery_info.address.street }}
                                 д. {{ props.row.delivery_info.address.house }} кв.
                                {{ props.row.delivery_info.address.apartment }}
                            </p>
                            <p v-if="props.row.delivery_info.address.porch !== null">
                                Подъезд: {{ props.row.delivery_info.address.porch }}
                            </p>
                            <p v-if="props.row.delivery_info.address.floor !== null">
                                Этаж: {{ props.row.delivery_info.address.floor }}
                            </p>
                            <p v-if="props.row.delivery_info.to_the_door !== null">
                                До двери? {{ props.row.delivery_info.to_the_door ? 'да' : 'нет' }}
                            </p>
                            <p v-if="props.row.delivery_info.to_the_door_climb !== null">
                                Тип подъема: {{ getHumanValue(props.row.delivery_info.to_the_door_climb, climbType) }}
                            </p>
                            </div>
                            <div v-else-if="props.row.storage">
                                <p>
                                    Магазин: {{ props.row.storage.title }}
                                </p>
                                <p>
                                    Адрес: {{ props.row.storage.address }}
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="Id"
                            width="50"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="user_info.full_name"
                            label="Имя заказчика"
                    />
                    <el-table-column
                            prop="status"
                            label="Статус заказа"
                    >
                        <template #default="scope">
                            {{ getHumanValue(scope.row.status, statusOrder) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="delivery_type"
                            label="Тип доставки"
                    >
                        <template #default="scope">
                            {{ getHumanValue(scope.row.delivery_type, deliveryType) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="payment_type"
                            label="Тип оплаты"
                    >
                        <template #default="scope">
                            {{ getHumanValue(scope.row.payment_type, paymentTypeOrder) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            label="Дата создания заказа"
                    >
                        <template #default="scope">
                            {{ getHumanDate(scope.row.created_at) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="Действия"
                            width="400"
                    >
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                @click="updateRow(scope.$index)">Детальная информация
                            </el-button>

                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
            <el-footer height="5%">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page.sync="current"
                        @current-change="getPage(current)"
                        :hide-on-single-page="true"
                        :page-size="paginator.per_page"
                        :page-count="paginator.last_page"
                >
                </el-pagination>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
import axios from "axios";
import sortConfig from '../../composable/config/order-sort.config'
import filterStatusConfig from '../../composable/config/order-status.config'
import statusOrder from '../../composable/type/status-order.type';
import paymentTypeOrder from '../../composable/type/payment-type-order.type';
import deliveryType from '../../composable/type/delivery.type';
import climbType from '../../composable/type/climb.type';
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
    name: "Advantages",
    data: function () {
        return {
            sortConfig,
            statusOrder,
            paymentTypeOrder,
            filterStatusConfig,
            climbType,
            deliveryType,
            status: 0,
            orders: [],
            paginator: [],
            current: 0,
            total: 0,
            onlySupply: false,
            query: {
                orderId: '',
                customerName: '',
                sort: sortConfig[0].field,
                status: '',
                page: 1,
            }
        }
    },
    mounted() {
        this.initParams(this.$route.query);
        this.getOrders(this.getQuery(this.$route.query));
    },
    computed: {
        activeSort() {
            const result = this.sortConfig.find((e) => e.field === this.query.sort)
            return result ? result.options  : undefined
        },
    },
    watch:{
    '$route.query'(v){   
      const query = this.getQuery(v)   
            if (query){              
                this.getOrders(query)
            }
        }
    },
    methods: {
        getHumanValue(targetValue, confgiObject) {
            for(const value of Object.values(confgiObject)) {
                if (value.value === targetValue) {
                    return value.title
                }
            }
            return ''
        },
        getHumanDate(value){
            const date = new Date(value)
            if (date) {
                const  options = { year: 'numeric', month: 'short', day: 'numeric' };
                const result = date.toLocaleDateString('ru-Ru', options)
                return result 
            }
            return ''
        },
        getOrders: function (query) {
            this.$store.commit(SETPRELOADER_STATE, true)
            axios.get(`order/${query}`).then((response) => {
                    this.orders = response.data.data;
                    this.paginator = response.data.meta;
                    this.current = response.data.meta.current_page;
                    this.total = response.data.meta.total;
                }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                }
            })
            .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
        },
        getPage: function (pageNum) {                     
            if (pageNum !== null) { 
                this.query.page = pageNum
                this.setQuery();            
            }
            this.success = '';
            return this.paginator.from
        },

        goToPage: function (path) {
            this.$router.push(path);
        },
        updateRow: function (index) {
            let id = this.orders[index].id;
            this.$router.push(`/order/${id}`);
        },

        setQueryReset(){
            this.query.page = 1
            this.setQuery()
        },

        setQuery(){
            const result = {}
            let isChange = false;
            if (this.activeSort) {
                isChange = true
                result['sort']= {
                    by: this.activeSort.by,
                    order: this.activeSort.order
                }  
            }
            if (this.query.customerName) {
                isChange = true
                result['q']=this.query.customerName
            }
            if (this.query.status) {
                isChange = true
                result['status']=this.query.status
            }
            if (this.query.orderId) {
                isChange = true
                result['order_id']=this.query.orderId
            }
            if (this.onlySupply) {
                isChange = true
                result['only_supply']=this.onlySupply ? 1 : 0
            }
            if(this.query.page){
                isChange = true
                result['page']=this.query.page
            }

            if (isChange) {
                const q = this.getQuery(result)
                this.$router.push({
                 path: 'orders' + q,
                })
            }
        }, 
        getQuery(query) {
            if (Object.keys(query).length > 0){        
                const qs = require('qs');
                return `?${qs.stringify(query)}`
            }
            return ''
        },
        initParams(query){
            if (!query){
                return
            }
            const qs = require('qs');
            const parseQuery= qs.parse(query);

            if (parseQuery.sort?.by && parseQuery.sort?.order) {
                this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
            }
            if (parseQuery.q){
                this.query.customerName = query.q
            }
            if (parseQuery.order_id) {
                this.query.orderId = query.order_id
            }
            if (parseQuery.status){
                this.query.status = parseQuery.status
            }
            if(parseQuery.only_supply){
                this.onlySupply = !!parseQuery.only_supply
            }
            if (parseQuery.page){
                this.query.page = parseQuery.page
            }
        }
    }
}
</script>

<style scoped>

</style>